// src/app/shared/components/tenant-selector/tenant-selector.component.ts
import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { CurrentService } from "app/services/current.service";
import { Tenant } from "app/services/models/tenant.model";
import { TenantService } from "app/services/tenant.service";
import { Subscription } from "rxjs";

@Component({
  selector: "navbar-tenant",
  templateUrl: "./navbar-tenant.component.html",
  styleUrls: ["./navbar-tenant.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TenantSelectorComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  tenants: Tenant[] = [];
  selectedTenantId: string | null = null;
  currentTenant: Tenant | null = null;

  constructor(
    private tenantService: TenantService,
    private currentService: CurrentService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.currentService.currentUser) {
      this.loadTenants(this.currentService.currentUser.value?.id);
      this.subscriptions.push(
        this.currentService.currentTenant.subscribe((tenant) => {
          this.currentTenant = tenant;
        })
      );

      if (this.tenantService.selectedTenant) {
        this.selectedTenantId = this.currentService.currentTenant?.value?.id;
      }
    }
  }

  loadTenants(userId): void {
    if (userId) {
      this.tenantService.getTenantsByUserId(userId).then((tenants) => {
        this.tenants = tenants?.data ?? [];
        this.tenants.forEach((t) => {
          t["disabled"] = t.isDeleted;
        });
      });
    }
  }

  onTenantChange(tenant: Tenant): void {
    if (this.currentService.currentUser) {
      const selectedTenant = this.tenants.find((t) => t.id === tenant.id) || null;

      this.tenantService.setCurrentTenant(selectedTenant).then((response) => {
        if (response.data && response.status == "success") {
          this.currentService.currentUser.next(null);
          const currentUrl = this.router.url;
          this.router
            .navigate(["/authentication/login"], {
              queryParams: { tenantId: tenant.id, returnUrl: currentUrl },
            })
            .then(() => {
              // window.location.reload();
            });
        }
      });
    } else {
      this.router.navigate(["/"]);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }
}
